import { gql } from '@apollo/client';

import { UserType } from '../types/user';

// QUERIES

export type CheckUserEmailAvailabilityType = {
	checkUserEmailAvailability: boolean;
};

export const CHECK_USER_EMAIL_AVAILABILITY = gql`
	query CheckUserEmailAvailability($email: String!) {
		checkUserEmailAvailability(email: $email)
	}
`;

// MUTATIONS

export type UpdateUserType = {
	updateUser: Pick<UserType, 'id' | 'firstName' | 'lastName' | 'email'>;
};

export type UpdateUserVariablesType = {
	updateUserInput: Pick<UserType, 'id'> & Partial<Pick<UserType, 'firstName' | 'lastName' | 'email'>>;
};

export const UPDATE_USER = gql`
	mutation updateUser($updateUserInput: UpdateUserInput!) {
		updateUser(updateUserInput: $updateUserInput) {
			id
			email
			lastName
			firstName
		}
	}
`;
